import React from 'react';
import ReactTable from 'react-table';

import moment from 'moment';
import DatePicker from 'react-datepicker';

import { TableComponent, connect } from './tableComponent';

const offerNames = {
  easysex: 'Easy',
  chatsales: 'HLink',
  andy: 'A',
  andy1: 'CPS',
  andy30: 'A3',
  andy60: 'A6',
  wellhello: 'Hello',
  chrissales: 'KLink',
  cevip: 'Cevip',
  cupid: 'Cupid',
  loc: 'Cupid3',
  sexplaycam: 'LCash',
  imlive: 'Live',
  spice: 'Spice',
  sandra_sales: 'Cams',
  // sms_chat: "SMS",
  hgh2: 'Hgh2',
  hg1: 'H1',
  hookupbay: 'HBay',
  dgold: 'DGold',
  punk: 'PunkBank',
  punk1: 'PunkBank1',
  sms: 'SLink'
};

class Component extends TableComponent {
  apiPath = 'affiliate/sales';
  editApiPath = 'master/sales_edit';

  initialState = {
    type: 'chat',
    checked: {}
  };

  state = {
    checked: []
  };

  resetOnMount = true;

  makeColumns = () => {
    let columns = [
      {
        Header: 'Sale id',
        accessor: 'sale_id',
        sortable: false,
        resizable: true,
        minWidth: 100
      },
      {
        Header: 'Date',
        id: 'date',
        accessor: (d) => moment(d.timenow * 1000).format('D MMM YYYY, hh:mm:ss'),
        sortable: false,
        resizable: true,
        minWidth: 150,
        Footer: (props) => <b>Total: {this.props.total.count || 0} sales</b>
      },
      {
        Header: 'Sub-affiliate',
        accessor: 'subaffiliate',
        sortable: false,
        resizable: true,
        minWidth: 80
      },
      {
        Header: 'Earned',
        accessor: 'total_dollars',
        sortable: false,
        resizable: true,
        minWidth: 60,
        Cell: (props) => (
          <input
            type='number'
            class='form-control form-control-sm text-center'
            min='0'
            max={
              (this.props.user.role_id == 4 && 1000) || this.props.user[props.original.earningsKey]
            }
            name={props.original.chat_sale_id}
            value={props.original.total_dollars}
            onChange={(e) => this.handleChangeData(e.target.value, props)}
            onBlur={(e) => {
              this.handleSubmitData(props);
            }}
          />
        )
      },
      {
        Header: 'Offer',
        id: 'offerKey',
        accessor: (d) => offerNames[d.offerKey],
        sortable: false,
        resizable: true,
        minWidth: 60
      },
      {
        Header: 'Link',
        id: 'url',
        accessor: 'url',
        sortable: false,
        resizable: true,
        minWidth: 320,
        Cell: (props) => {
          return <div style={{ whiteSpace: 'break-spaces', overflow: 'auto' }}>{props.value}</div>;
        }
      }
    ];
    if (this.props.user.role_id >= 3) {
      columns.unshift({
        Header: 'Delete',
        accessor: 'id',
        minWidth: 70,
        Cell: (props) => (
          <input
            type='checkbox'
            class='form-control'
            checked={!!this.state.checked[props.value]}
            onChange={(e) => this.checkForRemoval(props.value)}
          />
        ),
        Footer: (props) => (
          <button class='btn primary' onClick={this.removeSales}>
            Delete
          </button>
        )
      });
    }
    return columns;
  };

  checkForRemoval = (id) => {
    let checked = this.state.checked;
    if (checked[id]) {
      delete checked[id];
    } else {
      checked[id] = true;
    }
    this.setState({ checked });
  };

  removeSales = (e) => {
    e.preventDefault();
    let sales = Object.keys(this.state.checked);
    if (sales.length > 0 && confirm('Are you sure?')) {
      this.props
        .api('master/sales_remove', {
          sales: sales
        })
        .then((res) => {
          if (!res || res.result == 0) {
            alert('fail');
          } else {
            this.setState({
              checked: {}
            });
            this.fetchData({ forceReload: true });
          }
        });
    }
  };

  tableParams = {
    manual: true,
    class: 'text-center'
  };

  fetchParams = () => {
    return {
      wid: this.props.match.params.aid
    };
  };

  render() {
    console.log('affiliateSales render', this.props.items.length);
    return (
      <div>
        <div class='form-row row'>
          <div class='form-group col-12'>{this.datepickerElement()}</div>
        </div>
        <div class='row'>
          <div class='ml-3' style={{ width: '100%' }}>
            <div class='box'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'affiliate_sales');
